var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.haveProperties && _vm.haveStructure && _vm.haveLocalization)?_c('RouterView',{on:{"page":function($event){return _vm.$emit('page', $event)}}}):_c('div',{staticClass:"loading-overlay"},[_c('Loader',{staticClass:"overlay-spinner",attrs:{"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }